export const palette = {
	base: {
		white: '#FFFFFF',
		black: '#000000',
	},
	grey: {
		50: '#F9F9FC',
		100: '#F6F6FB',
		200: '#E1E1EE',
		300: '#C5C7DA',
		400: '#9DA0B6',
		500: '#71738D',
		600: '#585A71',
		700: '#3A3C52',
		800: '#2D3045',
		900: '#222539',
	},
	brand: {
		50: '#EEFCF5',
		100: '#E5FAF0',
		200: '#B9F4D8',
		300: '#84EBBB',
		400: '#47D793',
		500: '#21BA72',
		600: '#209F6D',
		700: '#1F8468',
		800: '#116951',
		900: '#084937',
	},
	red: {
		50: '#FFF0F3',
		100: '#FFE0E8',
		200: '#FCC5D2',
		300: '#F98BA5',
		400: '#F5426D',
		500: '#F31C50',
		600: '#CF1743',
		700: '#A81538',
		800: '#810E2A',
		900: '#60061C',
	},
	orange: {
		50: '#FFFAEB',
		100: '#FEF0C7',
		200: '#FEDF89',
		300: '#FEC84B',
		400: '#FDB022',
		500: '#F79009',
		600: '#DC6803',
		700: '#B54708',
		800: '#93370D',
		900: '#5C230A',
	},
	blue: {
		50: '#EBF2FF',
		100: '#CCDEFF',
		200: '#99BDFF',
		300: '#70A3FF',
		400: '#4789FF',
		500: '#337BFF',
		600: '#2067E9',
		700: '#1455CC',
		800: '#0F3E95',
		900: '#0B2F6F',
	},
	cyan: {
		50: '#ECFDFF',
		100: '#CFF9FE',
		200: '#A5F0FC',
		300: '#67E3F9',
		400: '#22CCEE',
		500: '#06AED4',
		600: '#088AB2',
		700: '#0E7090',
		800: '#155B75',
		900: '#134053',
	},
	violet: {
		50: '#F9F5FF',
		100: '#F4EBFF',
		200: '#E9D7FE',
		300: '#D6BBFB',
		400: '#B692F6',
		500: '#9E77ED',
		600: '#7F56D9',
		700: '#6941C6',
		800: '#53389E',
		900: '#42307D',
	},
	social: {
		vk: '#0077FF',
		telegram: '#3390EC',
		odnoklassniki: '#EE8208',
		twitter: '#1DA1F2',
		facebook: '#4267B2',
	},
	malachite: {
		200: '#E5FCF7',
		100: '#D6ECEA',
		300: '#90D0CC',
		400: '#21A19A',
		500: '#107F8C',
		600: '#107F8C',
		700: '#005E7F',
		800: '#4099A3',
	},
	primary: {
		highlight: {
			10: '#FFFFFF1A',
			20: '#FFFFFF33',
		},
	},
}
